import React from 'react';
import styles from './EmailInput.module.scss';

interface EmailInputProps {
  className?: string;
  placeholder?: string;
  value: string;
  sendValue: (value: string) => void;
  showError?: boolean;
}

const EmailInput = (props :EmailInputProps) => {
  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isValid = props.value === '' || isValidEmail(props.value);
  const shouldShowError = props.showError && !isValid;

  return (
    <div className={styles.EmailInput} data-testid="EmailInput">
      <input 
        className={`${styles.Input} ${shouldShowError ? styles.Invalid : ''}`}
        type="email"
        placeholder={props.placeholder}
        value={props.value}
        onChange={(e) => props.sendValue(e.target.value)}
      />
      {shouldShowError && <span className={styles.Error}>Please enter a valid email</span>}
    </div>
  );
};

export default EmailInput;
